/** @file findSlot: an image slot by key, with the entry that owns it (flattened attachment slots included). */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { deriveSlots } from '@zilo/pose3d-format/derive/deriveSlots';
import type { FacetEntry, ImageSlot } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** The slot `key` (`<drawable>/<entry>/<tile>`) and its entry; `NOT_FOUND` at `path` (hint: the first 10 keys). */
export function findSlot(puppet: Puppet, key: string, path = '/input/slot'): { slot: ImageSlot; entry: FacetEntry } {
  const slots = deriveSlots(puppet);
  const slot = slots.find((s) => s.key === key);
  const d = slot === undefined ? undefined : puppet.drawables.find((x) => x.id === slot.drawable);
  const entry = d?.kind === 'impostor' && slot !== undefined ? d.facets[slot.entry] : undefined;
  if (slot !== undefined && entry !== undefined) return { slot, entry };
  return throwError(ERROR_CODES.NOT_FOUND, { slot: key }, { path, hint: `slots: ${slots.slice(0, 10).map((s) => s.key).join(', ')}` });
}
